
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import TrustSection from './components/TrustSection';
import AboutSection from './components/AboutSection';
import CoverageSection from './components/CoverageSection';
import WhyChooseUsSection from './components/WhyChooseUsSection';
import ContactSection from './components/ContactSection';
import SeoJsonLd from '../../components/feature/SeoJsonLd';

export default function HomePage() {
  const newsletterFormUrl = 'https://readdy.ai/api/form/d60oh8oomoleh5thv9k0';

  return (
    <div className="min-h-screen">
      <SeoJsonLd />
      <Navbar />
      <HeroSection />
      <ServicesSection />
      <TrustSection />
      <CoverageSection />
      <WhyChooseUsSection />
      <ContactSection />
      <AboutSection />
      <Footer newsletterFormUrl={newsletterFormUrl} />
    </div>
  );
}
